const videoWrappers = document.querySelectorAll('.video');

videoWrappers.forEach(videoWrapper => {
    const video = videoWrapper.querySelector('video');
    const videoOverlay = videoWrapper.querySelector('.video__overlay');

    videoOverlay.addEventListener('click',  () => {
        video.play();
        videoOverlay.classList.add('d-none');
    });
});
